// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.master-project-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  overflow: hidden;
}

.master-project-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border-color: #d0d0d0;
}

.master-project-card.expanded {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.master-project-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  min-height: 80px;
}

.master-project-card.collapsed .master-project-header {
  border-bottom: none;
}

.master-project-header:hover {
  background: #e9ecef;
}

.master-project-info {
  display: flex;
  align-items: center;
  flex: 1 1;
  gap: 16px;
}

.expand-icon {
  font-size: 1.2rem;
  width: 24px;
  text-align: center;
}

.master-project-title h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
}

.master-project-title .description {
  margin: 4px 0 0 0;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;
}

.rename-form {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

.rename-input {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #007bff;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
}

.rename-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.rename-actions {
  display: flex;
  gap: 4px;
}

.rename-actions button {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.rename-actions .save-button:hover {
  background: #d4edda;
  color: #155724;
}

.rename-actions .cancel-button:hover {
  background: #f8d7da;
  color: #721c24;
}

.master-project-meta {
  display: flex;
  align-items: center;
  gap: 16px;
}

.project-count {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
  background: #e9ecef;
  padding: 4px 8px;
  border-radius: 12px;
}

.master-project-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.action-button {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  opacity: 0.8;
}

.action-button:hover:not(:disabled) {
  opacity: 1;
  background: rgba(0, 0, 0, 0.1);
}

.action-button:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.action-button.delete-button:hover:not(:disabled) {
  background: #f8d7da;
  color: #721c24;
}

.master-project-content {
  padding: 0;
}

.projects-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: white;
}

.projects-header span {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}

.add-project-button {
  background: #007bff;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-project-button:hover {
  background: #0056b3;
  transform: translateY(-1px);
}

.projects-list {
  max-height: 400px;
  overflow-y: auto;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.empty-state p {
  margin: 0 0 16px 0;
  font-size: 0.9rem;
}

.empty-state-button {
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.empty-state-button:hover {
  background: #218838;
  transform: translateY(-1px);
}

.project-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f8f9fa;
  transition: background-color 0.2s ease;
  gap: 16px;
  min-height: 60px;
}

.project-item:hover {
  background: #f8f9fa;
}

.project-item:last-child {
  border-bottom: none;
}

.project-info {
  flex: 1 1;
  text-align: left;
}

.project-info h4 {
  margin: 0 0 4px 0;
  font-size: 1rem;
  font-weight: 500;
  color: #007bff;
  cursor: pointer;
  transition: color 0.2s ease;
  text-align: left;
}

.project-info h4:hover {
  color: #0056b3;
  text-decoration: underline;
}

.project-description {
  margin: 0;
  font-size: 0.8rem;
  color: #666;
  line-height: 1.4;
  text-align: left;
}

.project-actions {
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  margin-left: 12px;
}

.project-item:hover .project-actions {
  opacity: 1;
}

.project-action-button {
  background: none;
  border: none;
  font-size: 0.9rem;
  cursor: pointer;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.project-action-button:hover {
  background: rgba(0, 0, 0, 0.1);
}

/* Three dots icon styles are handled by DropdownMenu.css */

.project-sequence {
  display: flex;
  align-items: center;
  min-width: 40px;
}

.sequence-number {
  font-weight: 600;
  font-size: 1rem;
  color: #007bff;
  min-width: 30px;
  text-align: center;
}

.project-reorder {
  display: flex;
  flex-direction: column;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
  margin-left: 8px;
}

.project-item:hover .project-reorder {
  opacity: 1;
}

.reorder-button {
  background: white;
  border: 1px solid #d0d0d0;
  font-size: 12px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: #666;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.reorder-button:hover:not(:disabled) {
  background: #f0f0f0;
  border-color: #007bff;
  color: #007bff;
}

.reorder-button:disabled {
  cursor: not-allowed;
  opacity: 0.3;
  border-color: #e9ecef;
  color: #adb5bd;
}

.master-project-footer {
  padding: 12px 20px;
  border-top: 1px solid #f0f0f0;
  background: #f8f9fa;
}

.master-project-footer small {
  color: #666;
  font-size: 0.8rem;
}

/* Responsive */
@media (max-width: 768px) {
  .master-project-header {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .master-project-meta {
    width: 100%;
    justify-content: space-between;
  }
  
  .projects-header {
    padding: 12px 16px;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .project-item {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .project-actions {
    opacity: 1;
    width: 100%;
    justify-content: flex-end;
  }
}`, "",{"version":3,"sources":["webpack://./src/MasterProjectCard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":[".master-project-card {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  margin-bottom: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  overflow: hidden;\n}\n\n.master-project-card:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  border-color: #d0d0d0;\n}\n\n.master-project-card.expanded {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.master-project-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px;\n  cursor: pointer;\n  user-select: none;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  min-height: 80px;\n}\n\n.master-project-card.collapsed .master-project-header {\n  border-bottom: none;\n}\n\n.master-project-header:hover {\n  background: #e9ecef;\n}\n\n.master-project-info {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  gap: 16px;\n}\n\n.expand-icon {\n  font-size: 1.2rem;\n  width: 24px;\n  text-align: center;\n}\n\n.master-project-title h3 {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.master-project-title .description {\n  margin: 4px 0 0 0;\n  font-size: 0.9rem;\n  color: #666;\n  line-height: 1.4;\n}\n\n.rename-form {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.rename-input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #007bff;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.rename-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.rename-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.rename-actions button {\n  background: none;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n}\n\n.rename-actions .save-button:hover {\n  background: #d4edda;\n  color: #155724;\n}\n\n.rename-actions .cancel-button:hover {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.master-project-meta {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.project-count {\n  font-size: 0.9rem;\n  color: #666;\n  font-weight: 500;\n  background: #e9ecef;\n  padding: 4px 8px;\n  border-radius: 12px;\n}\n\n.master-project-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.action-button {\n  background: none;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  opacity: 0.8;\n}\n\n.action-button:hover:not(:disabled) {\n  opacity: 1;\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.action-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.3;\n}\n\n.action-button.delete-button:hover:not(:disabled) {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.master-project-content {\n  padding: 0;\n}\n\n.projects-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  background: white;\n}\n\n.projects-header span {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.add-project-button {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.add-project-button:hover {\n  background: #0056b3;\n  transform: translateY(-1px);\n}\n\n.projects-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n}\n\n.empty-state p {\n  margin: 0 0 16px 0;\n  font-size: 0.9rem;\n}\n\n.empty-state-button {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.empty-state-button:hover {\n  background: #218838;\n  transform: translateY(-1px);\n}\n\n.project-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f8f9fa;\n  transition: background-color 0.2s ease;\n  gap: 16px;\n  min-height: 60px;\n}\n\n.project-item:hover {\n  background: #f8f9fa;\n}\n\n.project-item:last-child {\n  border-bottom: none;\n}\n\n.project-info {\n  flex: 1;\n  text-align: left;\n}\n\n.project-info h4 {\n  margin: 0 0 4px 0;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #007bff;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  text-align: left;\n}\n\n.project-info h4:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n.project-description {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #666;\n  line-height: 1.4;\n  text-align: left;\n}\n\n.project-actions {\n  display: flex;\n  gap: 8px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  margin-left: 12px;\n}\n\n.project-item:hover .project-actions {\n  opacity: 1;\n}\n\n.project-action-button {\n  background: none;\n  border: none;\n  font-size: 0.9rem;\n  cursor: pointer;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.project-action-button:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n/* Three dots icon styles are handled by DropdownMenu.css */\n\n.project-sequence {\n  display: flex;\n  align-items: center;\n  min-width: 40px;\n}\n\n.sequence-number {\n  font-weight: 600;\n  font-size: 1rem;\n  color: #007bff;\n  min-width: 30px;\n  text-align: center;\n}\n\n.project-reorder {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  margin-left: 8px;\n}\n\n.project-item:hover .project-reorder {\n  opacity: 1;\n}\n\n.reorder-button {\n  background: white;\n  border: 1px solid #d0d0d0;\n  font-size: 12px;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  color: #666;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.reorder-button:hover:not(:disabled) {\n  background: #f0f0f0;\n  border-color: #007bff;\n  color: #007bff;\n}\n\n.reorder-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.3;\n  border-color: #e9ecef;\n  color: #adb5bd;\n}\n\n.master-project-footer {\n  padding: 12px 20px;\n  border-top: 1px solid #f0f0f0;\n  background: #f8f9fa;\n}\n\n.master-project-footer small {\n  color: #666;\n  font-size: 0.8rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .master-project-header {\n    padding: 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .master-project-meta {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .projects-header {\n    padding: 12px 16px;\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n  \n  .project-item {\n    padding: 12px 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .project-actions {\n    opacity: 1;\n    width: 100%;\n    justify-content: flex-end;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
